<div class="settingPostion">

  <button class="btn btn-outline-secondary btn-sm" type="button" data-bs-toggle="offcanvas"
    data-bs-target="#settingsOffcanvas" aria-controls="settingsOffcanvas">
    {{ 'HOME.SETTINGS_BUTTON' | translate }}
  </button>

  <div class="offcanvas offcanvas-start" tabindex="-1" id="settingsOffcanvas" aria-labelledby="settingsOffcanvasLabel">
    <div class="avatarwrap" style="height: 100vh;">
      <div>
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="settingsOffcanvasLabel">{{ 'SETTINGS_OFFCANVAS.TITLE' | translate }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas"
            [attr.aria-label]="'SETTINGS_OFFCANVAS.CLOSE_BUTTON_ARIA_LABEL' | translate"></button>
        </div>
      </div>

      <div class="scroll-box">
        <div class="" style="text-align: left;margin: 10px;">
          <!-- <div (click)="goToPersonalInfo()" class="d-flex align-items-center"
            style="cursor: pointer; padding: 0.5rem 0;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-person-fill me-2" viewBox="0 0 16 16">
              <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
            </svg>
            <span>{{ 'HOME.PERSONAL_BUTTON' | translate }}</span>
          </div> -->
          <!-- <hr class="mb-auto"> -->
          <div (click)="goToChangePasswordPage()" class="d-flex align-items-center mt-4"
            style="cursor: pointer; padding: 0.5rem 0;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-key-fill me-2" viewBox="0 0 16 16">
              <path
                d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
            </svg>
            <span>{{ 'HOME.CHANGE_PASSWORD_BUTTON' | translate }}</span>
          </div>
          <hr class="mb-auto">
        </div>
      </div>

      <div style="margin: 10px;">
        <div class="d-grid gap-2">
          <button class="btn button-primary-purple btn-lg" (click)="logout()" [disabled]="isLoggingOut">
            <span *ngIf="isLoggingOut; else logoutButtonText">
              {{ 'SETTINGS_OFFCANVAS.LOGGING_OUT_BUTTON' | translate }} <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </span>
            <ng-template #logoutButtonText>{{ 'HOME.LOGOUT_BUTTON' | translate }}</ng-template>
          </button>
        </div>
      </div>
      <div style="height: 80px;"></div>
    </div>

  </div>
</div>